import { useEffect, useRef } from "react";
import Userback from "@userback/widget";
import User from "../classes/User";

const USERBACK_TOKEN = process.env.REACT_APP_USERBACK_TOKEN;

export const useUserback = (user: User | null | undefined) => {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!user || initializedRef.current || !USERBACK_TOKEN) return;

    const initUserback = async () => {
      try {
        console.log("Initializing Userback for user:", user.id, user.email);
        await Userback(USERBACK_TOKEN, {
          user_data: {
            id: user.id,
            info: {
              name: user.name,
              email: user.email,
            },
          },
        });
        initializedRef.current = true;
      } catch (error) {
        console.error("Failed to initialize Userback:", error);
      }
    };

    initUserback();
  }, [user]);
};
